module.exports = __webpack_public_path__ + "img/01titile_m.8522a771.png";